
import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';

// ImportaciÃ³n de Angular Fire 2
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFirestoreModule } from 'angularfire2/firestore';

// Routing
import { AppRouting } from './app.routing';
import { AppGuard } from './app.guard';

// MÃ³dulos
import { SharedModule } from './shared/shared.module';



// ImportaciÃ³n del componente principal de la app
import { AppComponent } from './app.component';

import { LoginComponent } from './components/login/login.component';
import { CotizacionComponent } from './components/cotizacion/cotizacion.component';
import { ConfirmacionComponent } from './components/confirmacion/confirmacion.component';
import { ViajeVistaOperadorComponent } from './components/viaje-vista-operador/viaje-vista-operador.component';
import { InfoVentasDiariasComponent } from './components/info-ventas-diarias/info-ventas-diarias.component';

// Servicios
import { UsuariosPersonalService } from './services/usuarios-personal.service';
import { CatalogosService } from './services/catalogos.service';
import { PendientesService } from './services/pendientes.service';
import { UnidadesService } from './services/unidades.service';
import { ClientesService } from './services/clientes.service';
import { ContactosService } from './services/contactos.service';
import { CotizacionesService } from './services/cotizaciones.service';
import { CSVService } from './services/csv.service';
import { ConfirmacionesService } from './services/confirmaciones.service';
import { ServiciosService } from './services/servicios.service';
import { PagosService } from './services/pagos-service.service'
import { CargaDeGasolinaService } from'./services/carga-de-gasolina.service'
import { ServicioGenerarId } from'./services/generar-id.service'
import { ServicioBuscarGeoCode } from './services/geocoding.service';
import { AlgoritmoVentaTrosten } from './services/algoritmo-venta-trosten.service';
import { ServicioBuscarIdCaseta } from './services/buscar-id-caseta.service';
import { ServicioGenerarObjetos } from './services/generar-objetos-select.service';
import { EnviarCorreoService } from './services/enviar-correo.service';
import { ContadoresService } from './services/contadores.service';
import { ChatService } from './services/chat.service';
import { OxxoService } from './services/oxxo.service';
import { UtilidadesService } from './services/utilidades.service';
import { GoogleMapaService } from './services/google-map.service';
import { ViajesService } from './services/viajes.service'
import { ClientesConAcceso } from './services/clientes-con-acceso';
import { PushNotificationService } from './services/pushNotification.service';
import {ValidarDepartamentoService} from "./services/validarDepartamento";
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import { MailService } from './services/mail.service';
import { DateFormatterService } from './services/helpers/date-formatter.service';
import { ErrorHandlerService } from './services/helpers/error-handler.service';
import { GeocodingHelperService } from './services/helpers/geocoding-helper.service';
import { PdfDataBuilderService } from './services/helpers/pdf-data-builder.service';
import { HubspotFormatterService } from './services/integration/hubspot/hubspot-formatter.service';
import { DateParserService } from './services/helpers/date-parser.service';
import { ChangeTrackerService } from './services/helpers/change-tracker.service';
import { ContactIdManagerService } from './services/helpers/contact-id-manager.service';
import { ServiceUnitsManagerService } from './services/business-logic/service-units-manager.service';
import { DiscountCalculatorService } from './services/business-logic/discount-calculator.service';
import { ServiceChangeNotificationService } from './services/integration/service-change-notification.service';
import { GoogleMapsHelperService } from './services/integration/google-maps/google-maps-helper.service';
import { WhatsappTemplateService } from './services/integration/whatsapp-template.service';
import { DistanceCalculatorService } from './services/business-logic/distance-calculator.service';
import { ServiceFormValidatorService } from './services/validators/service-form-validator.service';
import { ServiceCombinationBuilderService } from './services/business-logic/service-combination-builder.service';
import { ExcelReportService } from './services/helpers/excel-report.service';
import { CotizacionesDataTransformerService } from './services/helpers/cotizaciones-data-transformer.service';
import { AvailabilityCalculatorService } from './services/business-logic/availability-calculator.service';
import { UnitTypeMapperService } from './services/helpers/unit-type-mapper.service';
import { SolicitudDisponibilidadBuilderService } from './services/business-logic/solicitud-disponibilidad-builder.service';
import { PdfCotizacionBuilderService } from './services/helpers/pdf-cotizacion-builder.service';
import { CotizacionDataExtractorService } from './services/helpers/cotizacion-data-extractor.service';
import { InvoiceCalculatorService } from './services/business-logic/invoice-calculator.service';
import { ServiceNoteSaverService } from './services/business-logic/service-note-saver.service';
import { ServiceDetailDataLoaderService } from './services/helpers/service-detail-data-loader.service';
import { ContactLoaderService } from './services/helpers/contact-loader.service';
import { FirebaseMultipathUpdaterService } from './services/helpers/firebase-multipath-updater.service';
import { DisponibilidadGeneralHelperService } from './services/helpers/disponibilidad-general-helper.service';
import { DateUtilsService } from './services/helpers/date-utils.service';
import { EventosClienteService } from './services/eventos-cliente.service';
import { ZonasRojasService } from './services/integration/zonas-rojas/zonas-rojas.service';
import { ConfirmacionChangeMatrixService } from './services/business-logic/confirmacion-change-matrix.service';
import { IndicadoresPagosService } from './services/business-logic/indicadores-pagos.service';
import { MetricasService } from './services/monitoring/metricas.service';
import { MetricasInterceptor } from './services/monitoring/metricas.interceptor';
import { AppErrorHandler } from './services/monitoring/app-error-handler';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        CotizacionComponent,
        ConfirmacionComponent,
        ViajeVistaOperadorComponent,
        InfoVentasDiariasComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        AngularDateTimePickerModule,
        HttpModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AppRouting,
        SharedModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        AngularFirestoreModule,
    ],
    providers: [{
        provide: LOCALE_ID,
        useValue: 'es-MX',
    },
        AppGuard,
        UsuariosPersonalService,
        CatalogosService,
        PendientesService,
        UnidadesService,
        ClientesService,
        ContactosService,
        CotizacionesService,
        CSVService,
        ConfirmacionesService,
        MailService,
        ServiciosService,
        PagosService,
        CargaDeGasolinaService,
        ServicioGenerarId,
        ServicioBuscarGeoCode,
        AlgoritmoVentaTrosten,
        ServicioBuscarIdCaseta,
        ServicioGenerarObjetos,
        EnviarCorreoService,
        ContadoresService,
        ChatService,
        OxxoService,
        UtilidadesService,
        GoogleMapaService,
        ViajesService,
        ClientesConAcceso,
        PushNotificationService,
        ValidarDepartamentoService,
        DateFormatterService,
        ErrorHandlerService,
        GeocodingHelperService,
        PdfDataBuilderService,
        HubspotFormatterService,
        DateParserService,
        ChangeTrackerService,
        ContactIdManagerService,
        ServiceUnitsManagerService,
        DiscountCalculatorService,
        ServiceChangeNotificationService,
        GoogleMapsHelperService,
        WhatsappTemplateService,
        AvailabilityCalculatorService,
        UnitTypeMapperService,
        SolicitudDisponibilidadBuilderService,
        PdfCotizacionBuilderService,
        CotizacionDataExtractorService,
        DistanceCalculatorService,
        ServiceFormValidatorService,
        ServiceCombinationBuilderService,
        ExcelReportService,
        CotizacionesDataTransformerService,
        InvoiceCalculatorService,
        ServiceNoteSaverService,
        ServiceDetailDataLoaderService,
        ContactLoaderService,
        FirebaseMultipathUpdaterService,
        DisponibilidadGeneralHelperService,
        DateUtilsService,
        EventosClienteService,
        ZonasRojasService,
        ConfirmacionChangeMatrixService,
        IndicadoresPagosService,
        // TR-22: monitoreo (tiempos en MySQL + errores a Sentry)
        MetricasService,
        { provide: HTTP_INTERCEPTORS, useClass: MetricasInterceptor, multi: true },
        { provide: ErrorHandler, useClass: AppErrorHandler }
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }




// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/app.module.ts